import { render, staticRenderFns } from "./UserCustomersTable.vue?vue&type=template&id=7f0eff64&scoped=true"
import script from "./UserCustomersTable.vue?vue&type=script&lang=js"
export * from "./UserCustomersTable.vue?vue&type=script&lang=js"
import style0 from "./UserCustomersTable.vue?vue&type=style&index=0&id=7f0eff64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0eff64",
  null
  
)

export default component.exports